// src/pages/SalesRecord/index.js
import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import SalesRecordFilters from "./components/SalesRecordFilters";
import SalesRecordTable from "./components/SalesRecordTable";
import { fetchSalesRecord } from "./SalesRecordThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportSalesRecordCsv } from "./components/exportSalesRecordCsv";
import { selectAuthInfo } from "../Auth/authSelectors";

const { Title } = Typography;

const SalesRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  useEffect(() => {
    dispatch(fetchSalesRecord({})); // initial load
  }, [dispatch]);
const { filters, list, details } = useSelector((state) => state.salesRecord);
const authInfo = useSelector(selectAuthInfo);


  const reportRef = useRef(null);
const dataSource = useMemo(() => {
  const isItemBased = ["By Item", "By Tag", "By Group", "By Category"]
    .includes(filters.filterType);

  if (filters.recordType === "with item" && !isItemBased) {
    return details.flatMap((master) =>
      (master.details || []).map((detail, index) => ({
        ...detail,
        key: `${master.sale_id}-${index}`,
        sale_voucher_no: master.sale_voucher_no,
        acc_name:        master.acc_name,
        employee_name:   master.employee_name,
        created_date:    master.created_date,
      }))
    );
  }
  if (isItemBased) return details;
  return list;
}, [filters, list, details]);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,    
    documentTitle: "Sales Report",
    removeAfterPrint: true, // cleanup after printing
  });
const handleDownloadCsv = () => {
  exportSalesRecordCsv({
    dataSource,
    filters,
    authInfo,
    title:    "Sales Record",
    filename: "sales_record",
  });
};

const hasData = dataSource.length > 0;
  return (
    <div className="p-4">
      <App>        
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="sales-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Sales Record</Title>
            </Flex>
          }
         extra={
  <Flex gap={8}>
    {hasData && (
      <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
        {!screens.xs && "CSV"}
      </Button>
    )}
    <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
      {!screens.xs && "Print"}
    </Button>
  </Flex>
}
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },  
            body: { padding: 0 },                                    
          }}
        />

        <SalesRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <SalesRecordTable />
        </Card>
      </App>
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            title="Sales Record"
            mode="report-page"
            filters={filters}
            // columns={columns}
            // data={list}
            renderTable={() => (
            <SalesRecordTable pagination={false} printMode={true}/>   /* ✅ reuse your actual table */
            )}
          />
      </div>
    </div>
  );
};

export default SalesRecord;
